module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', {
    class: _vm.isInternalView ? 'internal-view-container' : ''
  }, [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                Campaign Summary\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-btn', {
    staticClass: "mr-1 secondary--text surface",
    on: {
      "click": function($event) {
        return _vm.cancelEdit('summary')
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editCampaignSummary && !_vm.uploadSubmitting) ? _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveEdit
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.editCampaignSummary && _vm.uploadSubmitting) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "dark": "",
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 20
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editCampaignSummary && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.editCampaignSummary = true
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": "",
      "title": "Edit Campaign Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_vm._l((_vm.campaign.angles), function(angle, index) {
    return _c('div', {
      key: index
    }, [(angle.context || _vm.editCampaignSummary) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "flex-one",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                        Campaign Context\n                      ")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
      staticClass: "report-summary-editor",
      attrs: {
        "solo": ""
      },
      model: {
        value: (angle.context),
        callback: function($$v) {
          _vm.$set(angle, "context", $$v)
        },
        expression: "angle.context"
      }
    }) : _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(angle.context))])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((angle.formats), function(format, index) {
      return _c('v-layout', {
        key: index,
        staticClass: "pb-5",
        attrs: {
          "wrap": ""
        }
      }, [(format.required_action || _vm.editCampaignSummary) ? _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Required action")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.required_action),
          callback: function($$v) {
            _vm.$set(format, "required_action", $$v)
          },
          expression: "format.required_action"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.required_action))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Image/Video Pointers")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.image_angle),
          callback: function($$v) {
            _vm.$set(format, "image_angle", $$v)
          },
          expression: "format.image_angle"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.image_angle))])], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Content Pointers")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.content_angle),
          callback: function($$v) {
            _vm.$set(format, "content_angle", $$v)
          },
          expression: "format.content_angle"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.content_angle))])], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "bottomLine",
        attrs: {
          "xs12": "",
          "md12": ""
        }
      })], 1)
    })], 2)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Campaign Period")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-layout', {
    staticClass: "pa-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "290px",
            "float": "left",
            "padding-right": "10px"
          },
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "solo": ""
          },
          model: {
            value: (_vm.campaign.startDate),
            callback: function($$v) {
              _vm.$set(_vm.campaign, "startDate", $$v)
            },
            expression: "campaign.startDate"
          }
        }, on))]
      }
    }], null, false, 521130108),
    model: {
      value: (_vm.startCal),
      callback: function($$v) {
        _vm.startCal = $$v
      },
      expression: "startCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.startCal = false
      }
    },
    model: {
      value: (_vm.campaign.startDate),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "startDate", $$v)
      },
      expression: "campaign.startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "max-width": "20px",
      "padding": "10px 2px 10px"
    },
    attrs: {
      "xs12": "",
      "md1": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "solo": ""
          },
          model: {
            value: (_vm.campaign.endDate),
            callback: function($$v) {
              _vm.$set(_vm.campaign, "endDate", $$v)
            },
            expression: "campaign.endDate"
          }
        }, on))]
      }
    }], null, false, 3415128048),
    model: {
      value: (_vm.endCal),
      callback: function($$v) {
        _vm.endCal = $$v
      },
      expression: "endCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.endCal = false
      }
    },
    model: {
      value: (_vm.campaign.endDate),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "endDate", $$v)
      },
      expression: "campaign.endDate"
    }
  })], 1)], 1)], 1) : _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.startDate) + " - " + _vm._s(_vm.endDate))])], 1)]), _vm._v(" "), ((_vm.campaign.lineUp && _vm.campaign.lineUp.length > 0) || _vm.editCampaignSummary) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Creator Line Up")]), _vm._v(" "), (_vm.showRequiredActions() && _vm.editCampaignSummary) ? _c('v-layout', {
    staticClass: "p-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "md3": ""
    }
  }, [_c('v-file-input', {
    attrs: {
      "accept": "image/png, image/jpeg, image/bmp",
      "label": "Select Pictures",
      "prepend-icon": "",
      "multiple": ""
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('image-swiper', {
    attrs: {
      "images": _vm.campaign.lineUp,
      "isShowDelete": _vm.showRequiredActions() && _vm.editCampaignSummary
    },
    on: {
      "delete": _vm.deleteImage
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.optionalRemarks || _vm.editCampaignSummary) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Remarks")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
    staticClass: "report-summary-editor",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaign.optionalRemarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "optionalRemarks", $$v)
      },
      expression: "campaign.optionalRemarks"
    }
  }) : _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.campaign.optionalRemarks))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.segment) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Creator Strategy")]), _vm._v(" "), _c('div', [(_vm.showRequiredActions()) ? _c('draggable', {
    staticClass: "row no-gutters flex-wrap flex-row fill-height",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "update": function($event) {
        return _vm.handleDragDropUpdate(_vm.campaign.segment)
      }
    },
    model: {
      value: (_vm.campaign.segment),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "segment", $$v)
      },
      expression: "campaign.segment"
    }
  }, _vm._l((_vm.campaign.segment), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2"
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  }), 1) : _vm._l((_vm.campaign.segment), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2"
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  })], 2)])]) : _vm._e()], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInternalView),
      expression: "isInternalView"
    }],
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                AI Analysis Summary\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-btn', {
    staticClass: "mr-1 secondary--text surface",
    on: {
      "click": function($event) {
        return _vm.cancelEdit('ai')
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "loading": _vm.generatingSummary,
      "color": "primary",
      "text": "",
      "title": "Generate with AI"
    },
    on: {
      "click": function($event) {
        return _vm.generateAISummary(false)
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic mr-2"
  }), _vm._v(" Generate with AI\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis && !_vm.uploadSubmitting) ? _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveEdit
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis && _vm.uploadSubmitting) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "dark": "",
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 20
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editAIAnalysis && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.editAIAnalysis = true
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": "",
      "title": "Edit AI Analysis Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [(_vm.campaign.AISummary || _vm.editAIAnalysis || _vm.campaign.AISummary === '') ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("AI-Powered Analysis")]), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-textarea', {
    staticClass: "report-summary-editor",
    attrs: {
      "solo": "",
      "auto-grow": "",
      "rows": "8"
    },
    model: {
      value: (_vm.campaign.AISummary),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "AISummary", $$v)
      },
      expression: "campaign.AISummary"
    }
  }) : _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.renderRemark(_vm.campaign.AISummary))
    }
  })], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInternalView),
      expression: "isInternalView"
    }],
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                AI Notable Comments\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-1",
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.aiCommentsLoading,
      "title": "Generate with AI"
    },
    on: {
      "click": _vm.fetchAINotableComments
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic"
  })]), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.campaign.commentAnalysisResult && _vm.campaign.commentAnalysisResult.notableComments && _vm.campaign.commentAnalysisResult.notableComments.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.aiHeaders,
      "items": _vm.campaign.commentAnalysisResult.notableComments,
      "items-per-page": 5,
      "loading": _vm.aiCommentsLoading,
      "loading-text": "Analyzing comments...",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.comment",
      fn: function(ref) {
        var item = ref.item;

        return [_c('p', [_vm._v(_vm._s(item.comment ? item.comment.comment : 'N/A'))])]
      }
    }, {
      key: "item.relevance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "color": item.relevance === 'RELEVANT' ? 'success' : 'error',
            "small": ""
          }
        }, [_vm._v("\n                            " + _vm._s(item.relevance) + "\n                        ")])]
      }
    }, {
      key: "item.reason",
      fn: function(ref) {
        var item = ref.item;

        return [_c('p', [_vm._v(_vm._s(item.reason))])]
      }
    }, {
      key: "item.checkbox",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateNotableCheckFromTable(item, $event)
            }
          },
          model: {
            value: (item.checked),
            callback: function($$v) {
              _vm.$set(item, "checked", $$v)
            },
            expression: "item.checked"
          }
        })]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("\n                        No notable comments found in the latest analysis.\n                    ")]
      },
      proxy: true
    }], null, false, 301129300)
  }) : _vm._e()], 1)])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499560d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/CampaignSummary.vue
// module id = 2110
// module chunks = 0